import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isNativeRuntime } from '@/lib/nativeRuntime';
import { getNormalizedUrl } from '@/lib/canonicalUrl';

/**
 * Component that enforces canonical URL rules:
 * - Removes trailing slashes from URLs
 * - Redirects to normalized URLs
 * 
 * Only runs on web (not native app)
 */
const CanonicalEnforcer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isNative = isNativeRuntime();

  useEffect(() => {
    // Skip for native apps - they use HashRouter
    if (isNative) return;

    const normalizedUrl = getNormalizedUrl();
    
    if (normalizedUrl) {
      // Use replace to avoid adding to history stack
      navigate(normalizedUrl, { replace: true });
    }
  }, [location.pathname, isNative, navigate]);

  return null;
};

export default CanonicalEnforcer;
